module.exports = __webpack_public_path__ + "static/media/teen_owl.0ac925a0.svg";